<template>
  <section id="contact" class="contact">
    <div class="container">
      <!-- `on-night` is the marker AppNavigation hit-tests for. The card, not
           the section: the light margin around it still reads as light. -->
      <div v-reveal class="contact-card on-night">
        <div class="contact-grid">
          <div class="contact-left">
            <span class="eyebrow contact-eyebrow">{{ $t("contact.badge") }}</span>
            <h2 class="contact-heading">
              {{ $t("contact.title") }}
              <em>{{ $t("contact.titleEm") }}</em>
            </h2>
            <p class="contact-intro">{{ $t("contact.description") }}</p>

            <div class="contact-methods">
              <a
                class="contact-method"
                href="mailto:hello@bjornkoemans.nl"
                data-cursor="hover"
              >
                <span class="contact-method-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <path d="m3 7 9 6 9-6" />
                  </svg>
                </span>
                <span>
                  <div class="contact-method-label">{{ $t("contact.email.label") }}</div>
                  <div class="contact-method-value">{{ $t("contact.email.value") }}</div>
                </span>
              </a>
              <div class="contact-method">
                <span class="contact-method-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
                    <path d="M12 22s7-7 7-13a7 7 0 0 0-14 0c0 6 7 13 7 13Z" />
                    <circle cx="12" cy="9" r="2.5" />
                  </svg>
                </span>
                <span>
                  <div class="contact-method-label">{{ $t("contact.location.label") }}</div>
                  <div class="contact-method-value">{{ $t("contact.location.value") }}</div>
                </span>
              </div>
              <a
                class="contact-method"
                href="https://github.com/bjornkoemans"
                target="_blank"
                rel="noopener"
                data-cursor="hover"
              >
                <span class="contact-method-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.9.58.11.79-.25.79-.56v-2c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.69-1.28-1.69-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.76 2.7 1.25 3.36.96.1-.75.4-1.25.73-1.54-2.55-.29-5.24-1.28-5.24-5.7 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.17 1.18a11 11 0 0 1 5.78 0c2.2-1.49 3.16-1.18 3.16-1.18.63 1.58.24 2.75.12 3.04.74.81 1.18 1.84 1.18 3.1 0 4.43-2.69 5.41-5.26 5.69.41.36.78 1.06.78 2.14v3.17c0 .31.21.68.79.56C20.21 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5Z" />
                  </svg>
                </span>
                <span>
                  <div class="contact-method-label">GitHub</div>
                  <div class="contact-method-value">@bjornkoemans</div>
                </span>
              </a>
              <a
                class="contact-method"
                href="https://www.linkedin.com/in/bjornkoemans"
                target="_blank"
                rel="noopener"
                data-cursor="hover"
              >
                <span class="contact-method-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5ZM.22 8h4.56v15H.22V8Zm7.42 0h4.37v2.05h.06c.61-1.16 2.1-2.38 4.32-2.38 4.62 0 5.47 3.04 5.47 7v8.33h-4.56v-7.39c0-1.76-.03-4.02-2.45-4.02s-2.83 1.92-2.83 3.9V23H7.64V8Z" />
                  </svg>
                </span>
                <span>
                  <div class="contact-method-label">LinkedIn</div>
                  <div class="contact-method-value">bjornkoemans</div>
                </span>
              </a>
            </div>
          </div>

          <ContactForm />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContactForm from "@/components/contact/ContactForm.vue";

export default {
  name: "ContactSection",
  components: { ContactForm },
};
</script>

<style scoped>
.contact {
  padding: 120px 0;
}
.contact-card {
  position: relative;
  border-radius: 36px;
  padding: 64px;
  overflow: hidden;
  background:
    radial-gradient(
      circle at 80% -10%,
      rgba(143, 178, 214, 0.28),
      transparent 55%
    ),
    radial-gradient(
      circle at -10% 110%,
      rgba(228, 176, 132, 0.16),
      transparent 60%
    ),
    linear-gradient(135deg, var(--color-night-soft), var(--color-night));
  color: #fff;
  box-shadow: 0 30px 80px rgba(14, 14, 17, 0.4);
}
@media (max-width: 720px) {
  .contact-card {
    padding: 40px 28px;
    border-radius: 28px;
  }
}
.contact-grid {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 64px;
  align-items: start;
  position: relative;
  z-index: 1;
}
@media (max-width: 900px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }
}
.contact-heading {
  font-size: clamp(40px, 5vw, 64px);
  font-weight: 700;
  line-height: 0.95;
  letter-spacing: -0.035em;
  margin: 18px 0 24px;
}
.contact-heading em {
  font-family: var(--font-serif);
  font-style: italic;
  font-weight: 400;
  color: var(--accent-light);
}
.contact-intro {
  font-size: 17px;
  line-height: 1.55;
  opacity: 0.85;
  max-width: 420px;
  margin-bottom: 36px;
}
.contact-eyebrow {
  color: var(--accent-light) !important;
}
.contact-eyebrow::before {
  background: currentColor;
}
.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}
.contact-method {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition:
    background 0.25s ease,
    transform 0.3s ease;
  color: #fff;
}
.contact-method:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: translateX(4px);
}
.contact-method-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.14);
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
.contact-method-label {
  font-size: 12px;
  opacity: 0.65;
  letter-spacing: 0.06em;
}
.contact-method-value {
  font-size: 15px;
  font-weight: 600;
}
</style>
